import { render } from "./practice-card.html?vue&type=template&id=542e7eac&scoped=true&ts=true&external"
import script from "./practice-card.ts?vue&type=script&lang=ts&external"
export * from "./practice-card.ts?vue&type=script&lang=ts&external"

import "./practice-card.scss?vue&type=style&index=0&id=542e7eac&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-542e7eac"]])

export default __exports__